// extracted by mini-css-extract-plugin
var _1 = "MinimizedModalsTrayItem-moduleMinimizedModalsTrayItem__iUTld";
var _2 = "MinimizedModalsTrayItem-modulecloseButton__Nf2Mc MinimizedModalsTrayItem-moduleiconButton__vG4NI ButtonIcon-moduleicon__Hawdx IconNG-moduleiconContainer__SxWZ0";
var _3 = "MinimizedModalsTrayItem-moduleiconButton__vG4NI ButtonIcon-moduleicon__Hawdx IconNG-moduleiconContainer__SxWZ0";
var _4 = "MinimizedModalsTrayItem-moduletitle__bvlJN";
export { _1 as "MinimizedModalsTrayItem", _2 as "closeButton", _3 as "iconButton", _4 as "title" }
